export default __webpack_public_path__ + "static/media/close_blue.9502df56.svg";